'use client';

import { KibChatFillIcon } from '@chewy/kib-icons-react';
import cx from 'classnames';
import Link from 'next/link';
import React from 'react';

import { PageType } from '../../constants';
import { CHAT_URL } from '../ChatNow/constants';

import styles from './styles.module.scss';

import { useChat } from '@/hooks/use-chat';

const InternalFooter = ({ pageType, className }: { pageType: PageType; className?: string }) => {
  const { handleChatClick } = useChat(pageType);

  return (
    <footer className={cx(styles.root, className)}>
      <ul>
        <li>
          <Link className={styles.link} href="/app/content/faq">
            Support / FAQs
          </Link>
        </li>
        <li>
          <Link className={styles.link} href={CHAT_URL} passHref onClick={handleChatClick}>
            <KibChatFillIcon
              aria-hidden="true"
              focusable="false"
              data-a11y="decorative"
              alt=""
              className={styles.chatIcon}
            />{' '}
            24/7 Chat
          </Link>
        </li>
      </ul>

      <small className={styles.version} aria-hidden="true">
        {process.env.version}
      </small>
    </footer>
  );
};

export default InternalFooter;
